import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledCollectionEntitiesTableViews
  from 'components/organisms/TableViews/CollectionEntitiesTableViews/CollectionEntitiesTableViews.styles';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';

const CollectionEntitiesTableViews = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'CollectionEntitiesTableViews');

  const tableProvider = useTable();
  const collection = tableProvider.context?.data;

  const isSuggestion = Boolean(tableProvider?.view?.activeViews?.find((v) => v.name === 'suggestions'));
  const isRejection = Boolean(tableProvider?.view?.activeViews?.find((v) => v.name === 'rejections'));

  const handleCanNotify = (view) => {
    const isNew = view.viewId === -1;
    return (isNew && !isSuggestion && !isRejection) || (
      !isNew && !view.settings?.list?.custom?.find((c) => ['suggestions', 'rejections'].includes(c))
    );
  }

  return <StyledCollectionEntitiesTableViews ref={ref} {...innerProps}
                                             collection={collection}
                                             onCanNotify={handleCanNotify}>
    {innerProps.children}
  </StyledCollectionEntitiesTableViews>
});

CollectionEntitiesTableViews.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default CollectionEntitiesTableViews;
